export default {
      id: "file_audio-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#file_audio",
      toString: function () {
        return this.url;
      }
    }